import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json'

// 创建一个axios实例
const request = axios.create({
  baseURL: 'https://scrm.bydt.com.cn/wechat/xhs'
  // baseURL: 'http://127.0.0.1:3030'
  // 定制后端返回的原始数据（data), 即未经过JSON格式处理的原始数据
  /* transformResponse: [function (data) {
    console.log(data)
    // axios默认在内部使用JSON.parse来转换处理原始数据
    return JSON.parse(data)
  }] */
})
export default request